import type { CatalogSet } from "./types";
import { makeResolver } from "./resolver";
import enFamily from "./en/family.json";
import enProfessional from "./en/professional.json";
import esFamily from "./es/family.json";

export const catalogs: CatalogSet = {
  en: { family: enFamily as Record<string, string>, professional: enProfessional as Record<string, string> },
  es: { family: esFamily as Record<string, string> },
};

export const resolve = makeResolver(catalogs);
